/**
 * @fileoverview トラブルシューティングページのトップコンテンツを記述したファイルです。
 */

import Accordion from "../components/Accordion.tsx";
import { Link } from "react-router-dom";
import cmcd_upload_error from "./img/cmcd_upload_error.png"

/**
 * 質問と回答のリスト
 */
const AccordionItems = [
  {
    title: "現象: 接続エラーウィンドウが表示される。",
    content: (
      <div>
        対処: 以下の項目を確認して下さい。
        <br />
        ・CMCD-200がパソコンに2台以上同時に接続されていないこと
        <br />
        ・CMCD-200の電源が入っていること
        <br />
        ・USBケーブルが取り付けられていること
        <br />
        ・パソコンにドライバーソフトウェアがインストールされていること
        <br />
        お使いのOSがWindows
        10または11の場合、正しいドライバーソフトウェアがインストールされていない可能性がございます。
        次のページを参考にドライバーソフトウェアの再インストールを行ってください。
        ⇒
        <Link to="/cmcd-200/HowToInstallDeviceDriver">
          デバイスドライバーのインストール方法
        </Link>
        <br />
        <br />
        <img src={cmcd_upload_error} alt="接続エラーウィンドウ" />
      </div>
    ),
  },
  {
    title: "現象: ソフトウェアをアンインストールしたい。",
    content: (
      <div>
        対処:
        パソコンに作られた「CMCD-200_Software」のフォルダを中のファイルごと削除し、デバイスドライバーをアンインストールします。
        デバイスドライバーのアンインストール方法は以下のページをご覧ください。
        <br />⇒
        <Link to="/cmcd-200/HelpAndSupport/HowToUninstallDeviceDriver">
          デバイスドライバーのアンインストール方法
        </Link>
      </div>
    ),
  },
];

/**
 * Help and support page
 * @returns {JSX.Element} トラブルシューティングページの JSX element
 */
export function HelpAndSupport(): JSX.Element {
  return (
    <>
      <section className="c-section">
        <h2 className="p-heading-2">トラブルシューティング</h2>
        {/* アコーディオンインターフェイス ここから */}
        <Accordion items={AccordionItems} />
        {/* アコーディオンインターフェイス ここまで */}
      </section>
    </>
  );
}
